import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";

import iziToast from "izitoast";
import "izitoast/dist/css/iziToast.min.css";

const input = document.querySelector('#datetime-picker');
const startBtn = document.querySelector('[data-start]');
startBtn.disabled = true;
let userSelectedDate = null;

const options = {
    enableTime: true,
    time_24hr: true,
    defaultDate: new Date(),
    minuteIncrement: 1,
    onClose(selectedDates) {
        if (input.disabled) {
            return;
        }
        const selectedDate = selectedDates[0];
        const now = new Date();

        if (selectedDate <= now) {
            iziToast.error({
                messageColor: '#fff',
                backgroundColor: '#ef4040',
                message: 'Please choose a date in the future',
                position: 'topRight',
                progressBarColor: '#b51b1b',
            });
            userSelectedDate = null;
            startBtn.disabled = true;
        } else {
            userSelectedDate = selectedDate;
            startBtn.disabled = false;
        } 
    },
};

flatpickr(input, options);

const refs = {
    days: document.querySelector('[data-days]'),
    hours: document.querySelector('[data-hours]'),
    minutes: document.querySelector('[data-minutes]'),
    seconds: document.querySelector('[data-seconds]')
};

let timerId = null;

startBtn.addEventListener('click', () => {
    if (!userSelectedDate) return;
    startBtn.disabled = true;
    input.disabled = true;
    timerId = setInterval(() => {
        const now = new Date();
        const diff = userSelectedDate - now;
        if (diff <= 0) {
            clearInterval(timerId);
            timerId = null;
            refs.days.textContent = '00';
            refs.hours.textContent = '00';
            refs.minutes.textContent = '00';
            refs.seconds.textContent = '00';
            input.disabled = false;
            startBtn.disabled = true;
            return;
        }
        const time = convertMs(diff);
        refs.days.textContent = addLeadingZero(time.days);
        refs.hours.textContent = addLeadingZero(time.hours);
        refs.minutes.textContent = addLeadingZero(time.minutes);
        refs.seconds.textContent = addLeadingZero(time.seconds);
    }, 1000);
});

function convertMs(ms) {
    const second = 1000;
    const minute = second * 60;
    const hour = minute * 60;
    const day = hour * 24;

    const days = Math.floor(ms / day);
    const hours = Math.floor((ms % day) / hour);
    const minutes = Math.floor(((ms % day) % hour) / minute);
    const seconds = Math.floor((((ms % day) % hour) % minute) / second);

    return { days, hours, minutes, seconds }
}

function addLeadingZero(value) {
    return String(value).padStart(2, '0')
}






